"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useBreakpoint } from "@/lib/hooks";
import { footerHiddenOn } from "@/lib/footer-visibility";

export default function Footer() {
  const pathname = usePathname();
  const { isMobile } = useBreakpoint();

  if (footerHiddenOn(pathname, isMobile)) return null;

  return (
    <footer style={{ borderTop: "1px solid var(--color-border)", background: "var(--color-surface)", color: "var(--color-muted)" }}>
      <div style={{ maxWidth: 1120, width: "100%", boxSizing: "border-box", margin: "0 auto", padding: "18px 20px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 260px), 1fr))", gap: 14, alignItems: "center" }}>
        <div>
          <p style={{ margin: 0, fontSize: 12, lineHeight: 1.55 }}>
            OpenHomesAI helps buyers search, compare, and monitor homes with Mae, an AI home search agent. Listing details and estimates should be verified with agents, lenders, inspectors, and official sources.
          </p>
          <p style={{ margin: "6px 0 0", fontSize: 12, color: "var(--color-muted-3)", lineHeight: 1.4 }}>
            An Eleven Delta Partners product.
          </p>
        </div>
        <nav aria-label="Footer" style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "flex-start", alignItems: "center" }}>
          <Link href="/about" style={{ display: "inline-flex", alignItems: "center", minHeight: 44, padding: "0 8px", color: "var(--color-ink)", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
            About OpenHomesAI
          </Link>
          <a href="mailto:ty@elevendeltapartners.com" style={{ display: "inline-flex", alignItems: "center", minHeight: 44, padding: "0 8px", color: "var(--color-ink)", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
            Contact Us
          </a>
          <a
            href="mailto:ty@elevendeltapartners.com?subject=OpenHomesAI%20bug%20report&body=What%20happened%3A%0A%0AWhat%20I%20expected%3A%0A%0APage%2Furl%3A%0A%0ABrowser%2Fdevice%3A"
            style={{ display: "inline-flex", alignItems: "center", gap: 5, minHeight: 44, color: "var(--color-ink)", background: "var(--color-surface)", border: "1px solid var(--color-border)", borderRadius: "var(--radius-full)", padding: "0 12px", fontSize: 12, fontWeight: 700, textDecoration: "none" }}
          >
            Report a bug
          </a>
        </nav>
      </div>
    </footer>
  );
}
